<template>
  <div class="edit_opt_box">
    <p>{{ $_translations.value[text] }}</p>

    <ToggleGroupButton
      :selected="selected"
      :options="options"
      container-el-class="row-selector account"
      @update:selected="$emit('update:selected', $event)"
    />
  </div>
</template>

<script setup>
import ToggleGroupButton from '@/components/button/ToggleGroupButton.vue';

defineEmits(['update:selected']);

defineProps({
  text: {
    type: String,
    default: '',
  },
  selected: {
    type: [String, Number, Boolean],
    default: '',
  },
  options: {
    type: Array,
    default: () => [],
  },
});
</script>
